export const getScreenProperties = () => {
  let cssBreakpoint =
    window.getComputedStyle(document.body, ':before').content || 'not set';
  // Trim quotation marks on browser that include them (i.e. Chrome)

  if (
    cssBreakpoint.substring(0, 1) === '"' &&
    cssBreakpoint.substring(cssBreakpoint.length - 1) === '"'
  ) {
    cssBreakpoint = cssBreakpoint.substring(1, cssBreakpoint.length - 1);
  }

  const {
    innerWidth: screenWidth,
    innerHeight: screenHeight,
    visualViewport,
  } = window;

  return {
    screenWidth,
    screenHeight,
    cssBreakpoint,
    visualViewport: visualViewport?.height
      ? {
          height: visualViewport.height,
        }
      : null,
  };
};
